// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"4de5bcf0","161":"4fdae4e4","220":"2516fd11","372":"d475ace6","488":"97247185","532":"4e6bdfd0","593":"d857c78b","639":"1acb08c5","764":"89a605a1","906":"890517d8","911":"02116ff3","943":"80428f9d"}[chunkId] + ".chunk.js";
};